export enum DocumentRetrieveStatus
{
    UNKNOWN  = 0,
    Available = 1,
    Importing = 2,
    Imported = 3,
    Retrieving = 4,
    Retrieved = 5,
    Error = 6
}
